import styled from 'styled-components'

export const IconWrapper = styled.div<{ $copied: boolean }>`
  svg > path {
    stroke: ${({ theme, $copied }) => ($copied ? theme.colors.white : theme.colors.grey)};
  }

  &:hover {
    svg > path {
      stroke: ${({ theme, $copied }) => ($copied ? theme.colors.white : theme.colors.violet)};
    }
  }
`
